<template>
  <!-- 月次集計 -->
  <div id="total">
    <CCard>
      <CCardHeader><h2>月次集計</h2></CCardHeader>
      <CCardBody>
        <table class="table search-table">
          <tr>
            <th style="width: 100px; text-align: left;" class="horizontal-text">年月</th>
            <th style="width: 75px"></th>
            <th style="width: 50px"></th>
            <!-- 絞り込みの見出しぶん。年月の行に列を足したので幅も足す -->
            <th style="width: 75px"></th>
            <th colspan="2"></th>
          </tr>
          <tr>
            <td>
              <select
                class="custom-select preika-control--year"
                v-model="year"
               
              >
                <option
                  v-for="option in yearOption"
                  :value="option.id"
                  :key="option.id"
                >
                  {{ option.name }}
                </option>
              </select>
            </td>
            <td>
              <select
                class="custom-select preika-control--month"
                v-model="month"
               
              >
                <option
                  v-for="option in monthOption"
                  :value="option.id"
                  :key="option.id"
                >
                  {{ option.name }}
                </option>
              </select>
            </td>
            <td>業務分</td>
            <td>絞り込み</td>
            <td>
              <!-- 年月と同じ検索ボタンで送る。別の検索ボックスは置かない -->
              <input
                v-model="keyword"
                type="text"
                class="form-control"
                maxlength="100"
                placeholder="社員番号・氏名・所属で絞り込む"
                @keyup.enter="search"
              />
            </td>
            <td>
              <button class="btn btn-primary" @click="search">検索</button>
            </td>
          </tr>
        </table>
      </CCardBody>
      <template v-if="callFlg">
        <CCardBody>
          <div class="d-flex justify-content-end mb-2">
            <button class="btn btn-info ml-2" :disabled="items.length === 0" @click="openPDF()">
                PDF
            </button>
          </div>
          <!-- 0件（絞り込みに当たるものが無いときも）は、ほかの一覧と同じ文を、同じ案内の字で、表のすぐ上に出す。 -->
          <p v-if="emptyNote" class="text-muted">{{ emptyNote }}</p>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th scope="col" rowspan="2" width="50px">社員番号</th>
                  <th scope="col" rowspan="2" width="50px">社員名</th>
                  <!--
                    **労務法令の判定を出していないあいだは、列ごと消す。**

                    back は印を返さないので中身は空になるが、列だけ残ると
                    毎月かならず空欄が並ぶ。何かが壊れているのか、
                    誰も上限に触れていないのか、読み分けられない。
                  -->
                  <th v-if="legalComplianceEnabled" scope="col" rowspan="2"
                      width="60px" class="horizontal-text">上限</th>
                  <th scope="col" colspan="3" class="horizontal-text" width="50px">ステータス</th>
                  <th scope="col" rowspan="2" width="50px">所定労働日数</th>
                  <th scope="col" rowspan="2" width="50px">出勤日数</th>
                  <th scope="col" rowspan="2" width="50px">有休日数</th>
                  <th scope="col" rowspan="2" width="50px">代休日数</th>
                  <th scope="col" rowspan="2" width="50px">特別休暇日数</th>
                  <th scope="col" rowspan="2" width="50px">総労働時間</th>
                  <th scope="col" rowspan="2" width="50px">欠勤時間</th>
                  <th scope="col" rowspan="2" width="50px">固定内残業</th>
                  <th scope="col" rowspan="2" width="50px">固定外残業</th>
                  <th scope="col" rowspan="2" width="50px">残手全対象</th>
                  <th scope="col" rowspan="2" width="50px">残手割増のみ</th>
                  <th scope="col" rowspan="2" width="50px">法定休日勤務</th>
                  <th scope="col" rowspan="2" width="50px">深夜勤務</th>
                  <th scope="col" rowspan="2" width="50px">45時間超残業</th>
                  <th scope="col" rowspan="2" width="50px">60時間超残業</th>
                  <th scope="col" rowspan="2" width="50px">有休残日数</th>
                  <th scope="col" rowspan="2" width="50px">代休残日数</th>
                  <th scope="col" rowspan="2" width="50px">欠勤日数</th>
                  <th scope="col" rowspan="2" width="50px">非課税通勤費</th>
                  <th scope="col" rowspan="2" width="50px">経費</th>
                </tr>
                <tr>
                  <th class="horizontal-text" width="20px">勤怠</th>
                  <th class="horizontal-text" width="20px">経費</th>
                  <th class="horizontal-text" width="20px">交通費</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.name">
                  <td>{{ item.employee_id }}</td>
                  <td>{{ item.name }}</td>
                  <td
                    v-if="legalComplianceEnabled"
                    class="horizontal-text text-center"
                    nowrap
                    :style="overtimeAlertStyle(item.overtime_alert)"
                    :title="overtimeAlertDetail(item)"
                  >{{ overtimeAlertLabel(item.overtime_alert) }}</td>
                  <td :style="statusColor(displayStatus(item.status_work) )" class="horizontal-text"  nowrap>{{ displayStatus(item.status_work) }}</td>
                  <td :style="statusColor(displayStatus(item.status_expenses))" class="horizontal-text"  nowrap>{{ displayStatus(item.status_expenses) }}</td>
                  <td :style="statusColor(displayStatus(item.status_trans))" class="horizontal-text"  nowrap>{{ displayStatus(item.status_trans) }}</td>
                  <td class="text-right">{{ item.defined_attendance_day }}</td>
                  <td class="text-right">{{ item.sum_attendance_day }}</td>
                  <td class="text-right">{{ item.paid_holiday_used }}</td>
                  <td class="text-right">{{ item.substitute_holiday_used }}</td>
                  <td class="text-right">{{ item.special_holiday_used }}</td>
                  <td class="text-right">{{ item.sum_work_time }}</td>
                  <td class="text-right">{{ item.sum_deduction_time }}</td>
                  <td class="text-right">{{ item.sum_fixed_over_time }}</td>
                  <td class="text-right">{{ item.sum_over_time }}</td>
                  <td class="text-right">{{ item.full_over_time }}</td>
                  <td class="text-right">{{ item.just_pre_over_time }}</td>
                  <td class="text-right">{{ item.sum_holiday_time }}</td>
                  <td class="text-right">{{ item.sum_night_time }}</td>
                  <td class="text-right">{{ item.over_45_time }}</td>
                  <td class="text-right">{{ item.over_60_time}}</td>
                  <td class="text-right">{{ item.paid_holiday_remain }}</td>
                  <td class="text-right">{{ item.substitute_holiday_remain }}</td>
                  <td class="text-right">{{ item.absence_day }}</td>
                  <td class="text-right">{{ item.commuting_expenses }}</td>
                  <td class="text-right">{{ item.expenses }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="d-flex justify-content-center">
            <!-- ページング処理 -->
            <VPagination
              v-model="currentPage"
              :click-handler="changePage"
              :page-count="totalPages"
              :force-page="currentPage"
              :force-ellipses="true"
              :container-class="'pagination'"
              :page-class="'page-item'"
              :prev-text="'<'"
              :next-text="'>'"
              :prev-link-class="'page-link'"
              :next-link-class="'page-link'"
              :page-link-class="'page-link'"
              :class-prefix="'pagination'"
            />
          </div>
        </CCardBody>
      </template>
    </CCard>
  </div>
</template>
  
<script>
import ConstList from "./../../ConstList";
import { requestFailureMessage } from '@/utils/requestFailure';
import axios from "axios";
import moment from "moment";
import VPagination from "vuejs-paginate";
export default {
  name: "Total",
  components: {
    VPagination,
  },
  data() {
    return {
      year: "",
      month: "",
      /* いま効いている絞り込みの言葉。空なら絞り込んでいない */
      keyword: "",
      date: "",
      items: [],
      // 一覧を読み終えたか（読み込み中・失敗のときは false。0件の文を出すかどうかに使う）
      listLoaded: false,
      // 検索ごとの通し番号。最新の検索の応答だけが、一覧・0件の文・保存する検索条件を変える（古い応答は捨てる）
      listRequestNo: 0,
      callFlg: false,
      monthlyReportInfo: "",
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      // いま表に出している月（最後に［検索］した月）。選択欄と食い違ったら表を閉じる。
      searchedYear: "",
      searchedMonth: "",

      item: {
      over_45_time: "",
      over_60_time: ""
    },
    };
  },
  created() {
    this.yearOption = ConstList.YEAR_OPTION;
    this.monthOption = ConstList.MONTH_OPTION;
    this.reportInfo = ConstList.ROUTE_REPORT_INFO;
  },

  watch: {
    /*
     * **選択欄を変えたら、［検索］を押し直すまで古い月の表を閉じる。**
     *
     * 一覧には月の見出しが無く、月を示すのは選択欄だけ。選択欄だけ変えると、
     * 表は検索した月の行のまま、［PDF］・ページ送りが
     * 変えた後の月で動いていた（9月の行から10月の詳細や帳票が出る）。
     */
    year: function () {
      this.closeIfNotSearchedMonth();
    },
    month: function () {
      this.closeIfNotSearchedMonth();
    },
  },
  methods: {
    // 選択欄の年月が、表に出している月と違えば表を閉じる。
    closeIfNotSearchedMonth: function () {
      if (String(this.year) !== String(this.searchedYear) ||
          String(this.month) !== String(this.searchedMonth)) {
        this.callFlg = false;
      }
    },
    // 届いた応答で表を開いてよいか。選択欄も、最後に［検索］した月も、その応答の月のままのときだけ。
    // 待つあいだに選択欄を変えた・検索し直したのに開くと、選択欄と違う月の表で操作できてしまう。
    isStillSearchedMonth: function (year, month) {
      return String(this.year) === String(year) && String(this.month) === String(month) &&
        String(this.searchedYear) === String(year) && String(this.searchedMonth) === String(month);
    },
    /**
     * 検索ボタン・入力欄のEnterから呼ぶ。
     *
     * ページを1へ戻してから引き直す。5ページ目のまま絞り込むと、
     * 結果が1ページしか無いときに空の表になる。
     */
    search: function () {
      this.currentPage = 1;
      this.callList();
    },
    callList: function () {
      this.listLoaded = false;
      /*
       * **検索を重ねても、最新の検索の結果だけを画面に出す。**
       * 応答は頼んだ順に返るとは限らない。先の検索があとから返ると、新しい結果を古い結果で上書きし、
       * 古い検索の0件の文が、新しい検索の途中や失敗のあとにも出ていた。
       * 保存する検索条件も、返ったときの画面の値ではなく、頼んだときの値にする。
       */
      const requestNo = ++this.listRequestNo;
      const asked = {
        year: this.year,
        month: this.month,
        keyword: this.keyword,
        currentPage: this.currentPage,
        pageSize: this.pageSize,
      };
      this.callFlg = false;
      this.searchedYear = this.year;
      this.searchedMonth = this.month;
      // 頼んだ月。応答が届いたとき、選択欄・最後に検索した月と突き合わせる。
      const year = this.year;
      const month = this.month;
      const params = new URLSearchParams();
      params.append("year", this.year);
      params.append("month", this.month);
      this.fetchTotalPages();
      params.append("currentPage", this.currentPage);
      params.append("pageSize", this.pageSize);
      params.append("totalPages", this.totalPages);
      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/admin/total/List", {
          params: {
            year: this.year,
            month: this.month,
            currentPage: this.currentPage,
            pageSize: this.pageSize,
            // 空文字は渡さない。渡すと「空で絞り込む」形になりうる
            keyword: this.keyword || undefined,
          },
        })
        .then((response) => {
          // 古い検索の応答は捨てる。
          if (requestNo !== this.listRequestNo) return;
          if (!this.isStillSearchedMonth(year, month)) return;
          this.items = response.data;
          this.listLoaded = true;
          this.callFlg = true;
          // sessionStorageへ保存。
          //
          // **この画面だけの鍵にする。**もとは業務報告と同じ
          // monthlyreportsList-* を読み書きしていたので、業務報告で選んだ
          // 年月・絞り込みが月次集計へ漏れ、その逆も漏れていた。
          sessionStorage.setItem(
            "totalList-search-items",
            JSON.stringify(this.items)
          );
          sessionStorage.setItem(
            "totalList-search-params",
            JSON.stringify({
              year: asked.year,
              month: asked.month,
              // 戻ってきたときに年月と同じように絞り込みも復元する
              keyword: asked.keyword,
              currentPage: asked.currentPage,
              pageSize: asked.pageSize,
              totalPages: this.totalPages,
            })
          );
        })
        .catch((error) => {
        // 失敗の記録は、古い検索のものでも今までどおり送る（不具合を追う手がかり。記録を減らさない）。
        // 知らせを出すのは、記録を送り終えた時点でも最新の検索のときだけ（下のコールバックで確かめる）。
        axios
          .post(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError`,
            { error: String(error) },
            {
              headers: {
                'Content-Type': 'application/json'
              }
            }
          )
          .then(() => {
            // 記録を送るのを待つあいだに次の検索が始まっていたら、古い検索の失敗は知らせない（記録は送ってある）。
            if (requestNo !== this.listRequestNo) return;
            alert(requestFailureMessage(error));
          })
          .catch(() => {
            // 記録を送るのを待つあいだに次の検索が始まっていたら、古い検索の失敗は知らせない（記録は送ってある）。
            if (requestNo !== this.listRequestNo) return;
            alert(requestFailureMessage(error, ConstList.SYSTEM_COMMUNICATION_ERROR));
          })
        });
    },
    setBlue: function (bluenum, index) {
      if (this.blue[index][bluenum] === "blue") {
        this.blue[index].splice(bluenum, 1, "");
      } else {
        this.blue[index].splice(bluenum, 1, "blue");
      }
    },
    setYellow: function (yellownum, index) {
      if (this.yellow[index][yellownum] === "yellow") {
        this.yellow[index].splice(yellownum, 1, "");
      } else {
        this.yellow[index].splice(yellownum, 1, "yellow");
      }
    },
    // 承認状態の初期値
    displayStatus(status) {
    return status ? status : ConstList.UNSUBMITTED; 
  },
    // 承認状態の識別
    // 36協定などの上限。印だけを出し、詳しくは title で読ませる。
    //
    // **「触れていない」と「判定できていない」を分ける。**同じ見た目に
    // すると、見ていないことが見えなくなる。
    overtimeAlertLabel(level) {
      switch (level) {
        case "violation":
          return "超過";
        case "warning":
          return "注意";
        case "obligation":
          return "要通知";
        case "unknown":
          return "不明";
        default:
          return "";
      }
    },
    overtimeAlertStyle(level) {
      switch (level) {
        case "violation":
          return { color: "red", fontWeight: "bold" };
        case "warning":
          return { color: "orange", fontWeight: "bold" };
        case "obligation":
          return { color: "#0d6efd" };
        case "unknown":
          return { color: "gray" };
        default:
          return {};
      }
    },
    overtimeAlertDetail(item) {
      const messages = item && item.overtime_alert_messages;
      if (!messages || messages.length === 0) {
        return "";
      }
      return messages.join("\n");
    },
    statusColor(status) {
      switch (status) {
        case ConstList.REJECT:
        case ConstList.UNSUBMITTED: 
          return { color: 'red' };
        case ConstList.APPROVAL_PENDING:
          return { color: 'orange' };
        case ConstList.APPROVAL:
          return { color: 'green' };
        default:
          return {};
      }
    },
    //PDF出力メソッド
    openPDF: function () {
      const params = new URLSearchParams();
      params.append("year", this.year);
      params.append("month", this.month);

      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/admin/total/pdf", {
          params: params,
          responseType: "blob",
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl, "_blank");
        })
        .catch((error) => {
          axios
          .post(`${process.env.VUE_APP_API_ORIGIN}/error/frontError`, { error: error.message || String(error) }, { headers: { 'Content-Type': 'application/json' } })
          .then(() => {
            alert(requestFailureMessage(error));
          })
          .catch(() => {
            alert(requestFailureMessage(error, ConstList.SYSTEM_COMMUNICATION_ERROR));
          });
        });
    },

    // ページ変更
    changePage: function (page) {
      this.currentPage = page;
      this.callList();
    },
    // アイテム数とページサイズに基づいて合計ページ数を計算
    fetchTotalPages: function () {
      // 一覧と同じ検索の通し番号（callList が進めたあとに呼ばれる）。最新の検索の件数だけが、ページ数を変える。
      // 先の検索の件数があとから返ると、新しい検索の一覧に、古い検索のページ数が付いていた。
      const requestNo = this.listRequestNo;
      const params = new URLSearchParams();
      params.append("year", this.year);
      params.append("month", this.month);
      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/admin/total/count", {
          params: {
            year: this.year,
            month: this.month,
            // 一覧と同じ絞り込みで数える。片方だけだと件数がずれる
            keyword: this.keyword || undefined,
          },
        })
        .then((response) => {
          // 古い検索の件数は捨てる。
          if (requestNo !== this.listRequestNo) return;
          const totalCount = response.data;
          // **ページ数は最低1。**Math.ceil(0 / 10) は 0 で、0件のときに
          // ページャそのものが消えてしまう。
          this.totalPages = Math.max(1, Math.ceil(totalCount / this.pageSize));
          // 数え直したあとに、見ているページを 1〜totalPages へ収める。
          // 覚えていたページへ戻ったとき、そのあいだに件数が減っていると
          // 空の表になるので、収めた側で引き直す。
          const inRange = Math.min(Math.max(1, this.currentPage), this.totalPages);
          if (inRange !== this.currentPage) {
            this.currentPage = inRange;
            this.callList();
          }
        })
        .catch((error) => {
        // 失敗の記録は、古い検索のものでも今までどおり送る（不具合を追う手がかり。記録を減らさない）。
        // 知らせを出すのは、記録を送り終えた時点でも最新の検索のときだけ（下のコールバックで確かめる）。
        axios
          .post(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError`,
            { error: String(error) },
            {
              headers: {
                'Content-Type': 'application/json'
              }
            }
          )
          .then(() => {
            // 記録を送るのを待つあいだに次の検索が始まっていたら、古い検索の失敗は知らせない（記録は送ってある）。
            if (requestNo !== this.listRequestNo) return;
            alert(requestFailureMessage(error));
          })
          .catch(() => {
            // 記録を送るのを待つあいだに次の検索が始まっていたら、古い検索の失敗は知らせない（記録は送ってある）。
            if (requestNo !== this.listRequestNo) return;
            alert(requestFailureMessage(error, ConstList.SYSTEM_COMMUNICATION_ERROR));
          })
        });
    },
  },

  computed: {
    // 0件のときの案内。一覧を読み終えて0件のときだけ出す（開き直したときは読み込む前に表が出るので、件数だけでは決めない）。
    emptyNote: function () {
      return this.listLoaded && Array.isArray(this.items) && this.items.length === 0 ? ConstList.EMPTY : '';
    },
    /**
     * 労務法令の判定を出してよい段階か。**行から読む。**
     *
     * <p>この画面は「検索するまで取りに行かない」。機能一覧のために
     * `created()` で1本増やすと、その保証が壊れる（実際に試験が落ちた）。
     * back が行へ載せてくるので、そこから読む。</p>
     *
     * <p><b>既定は出さない側。</b>古い back や取得の失敗で欄が無いときに
     * 出す側へ倒すと、作りかけの印が並ぶ。</p>
     */
    legalComplianceEnabled() {
      const rows = Array.isArray(this.items) ? this.items : [];
      if (!rows.length) {
        return false;
      }
      return rows[0].legal_compliance_enabled === true;
    },
    // 入力欄を追加・削除出来るようにする
    lists: function () {
      return Array.from(Array(this.num).keys());
    },
  },

  mounted: function () {
    // 前回の検索パラメータがあれば取得。
    //
    // **鍵はこの画面のもの（totalList-*）。**業務報告と同じ鍵を見ていた
    // ため、片方で選んだ年月・絞り込みがもう片方へ漏れていた。
    // **確かめる鍵と、読む鍵も同じにする。**別の鍵（-items）の有無で
    // 判定して -params を読むと、片方だけ残っているときに
    // JSON.parse(null) で落ちる。
    const saved = sessionStorage.getItem("totalList-search-params");
    if (saved) {
      const params = JSON.parse(saved);
      this.year = params.year;
      this.month = params.month;
      // 古い保存分には keyword が無いので、その場合は絞り込み無しに戻す
      this.keyword = params.keyword || "";
      // **見ていたページへ戻す。**保存しているのだから復元する。
      // 件数が減っていることがあるので、数え直したあと
      // （fetchTotalPages）に 1〜totalPages へ収める。
      this.currentPage = Number(params.currentPage) || 1;
      this.callList();
      this.callFlg = true;
    }else{
      const today = moment().subtract(1, 'months');
      this.year = today.format("YYYY");
      this.month = today.format("M");
    }
  },
};
</script>
  
<style scoped>
td,
th {
  white-space: nowrap;
}
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

td {
  vertical-align: middle;
  white-space: nowrap;
}
th {
  writing-mode:vertical-rl;
}
.horizontal-text {
  writing-mode: horizontal-tb;
  text-align: center;
  vertical-align: middle;
}
</style>
  